import {iOppAddress, iOppContact, IOpportunityFE} from 'interfaces/IOpportunityFE'
import {JsonObject} from 'utilities/types'
import {CGraphEntity} from './graph_entity'
import {CNote} from './note'

export class COpportunity extends CGraphEntity<IOpportunityFE> implements IOpportunityFE {
  static children = {
    notes: CNote,
  }
  id: string
  description: string
  amount: number
  response_deadline_utc: string
  response_deadline_offset: string
  dept_path: string[]
  notice_id: string
  solicitation_number: string
  url: string
  office_address: iOppAddress
  office_address_id: string
  point_of_contact: iOppContact[]
  timestamp: string

  constructor(data: IOpportunityFE & JsonObject) {
    super('Opportunity', data)
    this.id = data.id
    this.description = data.description
    this.amount = data.amount
    this.response_deadline_utc = data.response_deadline_utc
    this.response_deadline_offset = data.response_deadline_offset
    this.dept_path = data.dept_path
    this.notice_id = data.notice_id
    this.solicitation_number = data.solicitation_number
    this.url = data.url
    this.office_address_id = data.office_address_id
    this.office_address = data.office_address
    this.point_of_contact = data.point_of_contact
    this.timestamp = data.timestamp
  }
  stringify() {
    return JSON.stringify(this.export())
  }
}
